import { BaseEntity } from "yt-ng-framework";

export class TipRadneOpreme extends BaseEntity {
    constructor(){
        super();
    }

    Naziv: string = null;
    VelicinaSetID:number =null;

    Deserialize(input: any){
        this.ID = input.ID;
        this.Naziv = input.Naziv;
        this.VelicinaSetID=input.VelicinaSetID;
        return this;
    }

    Serialize(input: TipRadneOpreme){
        return input;
    }

}